/* =============================================================
 * SicilyAddict - carrello laterale Rebuy: testi e piccoli comportamenti (stile in sa-cart.css)
 * -------------------------------------------------------------
 * Rebuy disegna il carrello con Vue: qui si cambia solo il valore dei nodi di testo
 * (nodeValue), mai i nodi stessi, cosi' Rebuy continua ad aggiornarli; a ogni suo
 * aggiornamento i testi vengono riscritti.
 *  - spedizione gratuita: frase propria con camioncino e importo verde in grassetto; a soglia raggiunta
 *    "Congratulazioni, hai ottenuto la spedizione gratuita." con coriandoli (una volta per sessione)
 *  - 10/2026: promo omaggio (window.saPromo, da snippets/sa-promo.liquid): se attiva, il riquadro mostra
 *    la frase e la barra a tappe con la foto del regalo (niente legenda, niente blocco regalo di Rebuy);
 *    stile in sa-fix-2026-10-07.css.
 *    Promo spenta o scaduta da Impostazioni tema = barra come prima.
 *  - 16-10-2026: promo "regalo con l'acquisto di un prodotto" (window.saPromo.type = 'product', es. panettoncino
 *    in omaggio con un panettone + codice NATALE10): barra della spedizione normale e, sotto, la riga promo
 *    con il codice applicabile in un tocco (pulsante e stile in snippets/sa-promo-code.liquid).
 *  - "Numero Articoli (1)" / "Totale (2 Articoli)" -> "Subtotale (1 articolo)" / "Subtotale (2 articoli)"
 *  - "VAI ALLA CASSA ->" -> "Vai alla cassa"
 *  - "Aggiungi al carrello" nei consigliati -> "Aggiungi"
 *  - codice sconto chiuso dietro "Hai un codice sconto?"
 *  - quantita' con risposta immediata (numero subito aggiornato, totali "in caricamento")
 *  - "Completa la tua cena siciliana" -> "Spesso acquistati insieme" (sottotitolo nascosto)
 *  - riga Klarna sopra "Vai alla cassa", come nella scheda prodotto
 *  - pallino dell'header allineato al carrello di Rebuy
 *  - carrello aperto: la pagina sotto resta ferma (niente scroll della pagina trascinando nel carrello)
 *  - in anteprima tema il carrello finisce sopra la barra di Shopify
 * ============================================================= */
(function () {
  'use strict';

  /* cambia una classe solo se serve: una scrittura inutile genera una mutazione e un nuovo giro */
  function cls(el, name, on) {
    if (el && el.classList.contains(name) !== !!on) el.classList.toggle(name, !!on);
  }

  function setText(el, fn) {
    if (!el) return;
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType !== 3 || !n.nodeValue.trim()) continue;
      var next = fn(n.nodeValue);
      if (next !== n.nodeValue) n.nodeValue = next;
    }
  }

  /* ---------- spedizione gratuita: frase propria con camioncino e importo in evidenza ---------- */
  var TRUCK = '<span class="sa-ship-msg__icon" aria-hidden="true">🚚</span>';
  var GIFT = '<span class="sa-ship-msg__icon" aria-hidden="true">🎁</span>';
  var STORE_KEY = 'sa_free_ship_reached';

  function readStore() { try { return sessionStorage.getItem(STORE_KEY); } catch (e) { return null; } }
  function writeStore(v) { try { sessionStorage.setItem(STORE_KEY, v); } catch (e) {} }

  function shipMsg(wrap) {
    var msg = wrap.querySelector('.sa-ship-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'sa-ship-msg';
      msg.setAttribute('aria-live', 'polite');
      wrap.insertBefore(msg, wrap.firstChild);
    }
    return msg;
  }

  function shipping(root) {
    var pb = root.querySelector('[data-rebuy-component="progress-bar"]');
    if (!pb) return;
    var wrap = pb.querySelector('.rebuy-cart__progress-bar-wrapper');
    var prompt = pb.querySelector('.rebuy-cart__progress-bar-prompt');
    var fill = pb.querySelector('.rebuy-cart__progress-bar-meter-fill');
    if (!wrap || !prompt) return;

    promoNote(wrap);
    if (promoShipping(root, pb, wrap)) return;
    cls(pb, 'sa-has-promo', false);
    hideRebuyExtras(pb, wrap, false);
    var oldTiers = wrap.querySelector('.sa-tiers');
    if (oldTiers) oldTiers.parentNode.removeChild(oldTiers);

    var raw = prompt.textContent || '';
    var pct = fill ? parseFloat(fill.getAttribute('aria-valuenow')) : NaN;
    var missing = raw.match(/aggiungi ancora\s+(.+?)\s+e ricevi/i);
    var reached = !missing && (pct >= 100 || /gratuit/i.test(raw));
    var key, html;
    if (missing) {
      key = 'm:' + missing[1];
      html = TRUCK + '<span class="sa-ship-msg__text">Mancano <strong class="sa-ship-msg__amount">' + missing[1].replace(/</g, '') + '</strong> alla spedizione <span class="sa-ship-msg__free">gratuita</span></span>';
    } else if (reached) {
      key = 'ok';
      html = TRUCK + '<span class="sa-ship-msg__text"><strong>Congratulazioni</strong>, hai ottenuto la spedizione gratuita.</span>';
    } else {
      key = 't:' + raw;
      html = TRUCK + '<span class="sa-ship-msg__text"></span>';
    }
    var msg = shipMsg(wrap);
    cls(msg, 'sa-ship-msg--promo', false);
    if (msg.dataset.key !== key) {
      msg.innerHTML = html;
      if (key.charAt(0) === 't') msg.querySelector('.sa-ship-msg__text').textContent = raw.replace(/^\s*🚚\s*/, '');
      msg.dataset.key = key;
      msg.dataset.fitW = '';
    }
    fitShip(msg, reached);
    cls(pb, 'sa-ship-done', reached);

    /* festa una volta sola, quando la soglia viene superata con il carrello aperto */
    var visible = root.classList.contains('is-visible');
    if (reached) {
      if (readStore() !== '1' && visible) { writeStore('1'); celebrate(root, pb); }
    } else if (missing) {
      writeStore('0');
    }
  }

  /* ---------- promo omaggio: due tappe (regalo + spedizione gratuita) ----------
     window.saPromo = { on, gift (centesimi), ship (centesimi, 0 = nessuna soglia), end (ms), label, img }
     Il totale arriva dal carrello di Rebuy; se l'API non risponde si torna alla barra normale. */
  function promoCfg() {
    var P = window.saPromo;
    if (!P || !P.on || P.type === 'product' || !(P.gift > 0)) return null;
    if (P.end > 1e12 && Date.now() >= P.end) return null;
    return P;
  }
  function cartTotal() {
    try {
      var C = window.Rebuy && window.Rebuy.Cart;
      if (!C) return null;
      var cart = C.getCart && C.getCart();
      if (cart && typeof cart.total_price === 'number') return cart.total_price;
      var s = C.subtotal && C.subtotal();
      return typeof s === 'number' ? s : null;
    } catch (e) { return null; }
  }
  function amountTag(cents) { return '<strong class="sa-ship-msg__amount">' + esc(money(cents)) + '</strong>'; }

  function promoShipping(root, pb, wrap) {
    var P = promoCfg();
    if (!P) return false;
    var total = cartTotal();
    if (total === null) return false;

    var G = P.gift, S = P.ship > 0 ? P.ship : 0;
    var top = Math.max(G, S);
    var giftOk = total >= G, shipOk = S > 0 && total >= S;
    var allOk = giftOk && (S === 0 || shipOk);
    var close = S > 0 && Math.abs(G - S) <= 100; /* soglie quasi uguali (es. 79 e 79,90): una tappa sola */
    var label = esc(P.label || 'omaggio');
    var gl = '<strong>' + label + '</strong>';
    var text, icon = GIFT, state;

    if (allOk) {
      state = 'all';
      text = '<strong>Congratulazioni!</strong> ' + (S ? 'Spedizione gratuita e ' + label + ' sono tuoi.' : 'Hai sbloccato ' + gl + '.');
    } else if (giftOk) {
      state = 'gift';
      icon = TRUCK;
      text = '<strong>Omaggio sbloccato!</strong> Mancano ' + amountTag(S - total) + ' alla spedizione gratuita.';
    } else if (shipOk) {
      state = 'ship';
      text = '<strong>Spedizione gratuita ottenuta!</strong> Mancano ' + amountTag(G - total) + ' per ' + gl + '.';
    } else if (close) {
      state = 'both';
      text = 'Mancano ' + amountTag(top - total) + ' per la spedizione gratuita e ' + gl + '.';
    } else if (!S || G < S) {
      state = 'next-gift';
      text = 'Mancano ' + amountTag(G - total) + ' per ' + gl + '.';
    } else {
      state = 'next-ship';
      icon = TRUCK;
      text = 'Mancano ' + amountTag(S - total) + ' alla spedizione gratuita.';
    }

    var msg = shipMsg(wrap);
    cls(msg, 'sa-ship-msg--promo', true);
    var key = 'p:' + state + ':' + total;
    if (msg.dataset.key !== key) {
      msg.innerHTML = icon + '<span class="sa-ship-msg__text">' + text + '</span>';
      msg.dataset.key = key;
      msg.dataset.fitW = '';
    }

    var tiers = wrap.querySelector('.sa-tiers');
    if (!tiers) {
      tiers = document.createElement('div');
      tiers.className = 'sa-tiers';
      wrap.appendChild(tiers);
    } else if (tiers !== wrap.lastElementChild) {
      wrap.appendChild(tiers);
    }
    var pct = Math.max(0, Math.min(100, total / top * 100));
    var tkey = pct.toFixed(1) + '|' + giftOk + '|' + shipOk + '|' + G + '|' + S;
    if (tiers.dataset.key !== tkey) {
      tiers.innerHTML = tiersHtml(P, G, S, top, pct, giftOk, shipOk, allOk, close, label);
      tiers.dataset.key = tkey;
    }

    cls(pb, 'sa-has-promo', true);
    cls(pb, 'sa-ship-done', allOk);
    hideRebuyExtras(pb, wrap, true);

    var visible = root.classList.contains('is-visible');
    if (allOk) {
      if (readStore() !== '1' && visible) { writeStore('1'); celebrate(root, pb); }
    } else {
      writeStore('0');
    }
    return true;
  }

  /* ---------- promo "regalo con l'acquisto di un prodotto": riga sotto la barra ----------
     Creata una volta sola (cosi' il pulsante del codice resta verde dopo il tocco) e rimessa
     in fondo al riquadro se Rebuy ridisegna. */
  function promoNote(wrap) {
    var P = window.saPromo;
    var on = !!(P && P.on && P.type === 'product' && !(P.end > 1e12 && Date.now() >= P.end));
    var note = wrap.querySelector('.sa-promo-note');
    if (!on) { if (note) note.parentNode.removeChild(note); return; }
    if (!note) {
      note = document.createElement('div');
      note.className = 'sa-promo-note';
      var img = P.img ? '<img src="' + esc(P.img) + '" alt="" width="34" height="34" loading="lazy">' : '🎁';
      var code = '';
      if (P.code) {
        code = '<div class="sa-promo-note__code"><button type="button" class="sa-code" data-sa-code="' + esc(P.code) + '" data-done="Applicato" aria-label="Applica il codice sconto ' + esc(P.code) + '">' +
          '<span class="sa-code__val">' + esc(P.code) + '</span><span class="sa-code__act" aria-live="polite">Applica</span></button>' +
          (P.codeText ? '<span class="sa-promo-note__sub">' + esc(P.codeText) + '</span>' : '') + '</div>';
      }
      note.innerHTML = '<span class="sa-promo-note__img" aria-hidden="true">' + img + '</span><div class="sa-promo-note__body">' +
        '<p class="sa-promo-note__msg"><strong>' + esc(P.label || '') + '</strong>' + (P.sub ? ' ' + esc(P.sub) : '') + '</p>' + code + '</div>';
      wrap.appendChild(note);
      if (window.saCodeRestore) window.saCodeRestore();
    } else if (note !== wrap.lastElementChild) {
      wrap.appendChild(note);
    }
  }

  /* Con la promo attiva il riquadro mostra solo frase e tappe: il blocco "Il tuo regalo" di Rebuy
     (foto e nome dell'omaggio) e tutto cio' che sta accanto alla barra vengono nascosti. */
  function hideRebuyExtras(pb, wrap, on) {
    var node = wrap;
    while (node && node !== pb && node.parentElement) {
      Array.prototype.forEach.call(node.parentElement.children, function (sib) {
        if (sib !== node) cls(sib, 'sa-hide', on);
      });
      node = node.parentElement;
    }
  }

  function tiersHtml(P, G, S, top, pct, giftOk, shipOk, allOk, close, label) {
    var giftIco = P.img
      ? '<img class="sa-tiers__img" src="' + esc(P.img) + '" alt="" width="32" height="32" loading="lazy">'
      : '<span class="sa-tiers__emoji">🎁</span>';
    var truck = '<span class="sa-tiers__truck">🚚</span>';
    var nodes = [];
    if (close || !S) {
      nodes.push({ pos: 100, html: giftIco + (S ? truck : ''), done: allOk, cls: '' });
    } else {
      nodes.push({ pos: G / top * 100, html: giftIco, done: giftOk, cls: '' });
      nodes.push({ pos: S / top * 100, html: truck, done: shipOk, cls: ' sa-tiers__node--ship' });
    }
    var h = '<div class="sa-tiers__track" aria-hidden="true"><span class="sa-tiers__fill' + (allOk ? ' is-done' : '') + '" style="width:' + pct.toFixed(1) + '%"></span>';
    nodes.forEach(function (n) {
      h += '<span class="sa-tiers__node' + n.cls + (n.done ? ' is-done' : '') + '" style="left:' + n.pos.toFixed(1) + '%">' + n.html + '</span>';
    });
    h += '</div>';

    return h;
  }

  /* La frase deve stare su una riga: si rimpicciolisce fino a 12px secondo la larghezza del carrello;
     se non basta (schermi molto stretti) va a capo invece di essere tagliata. */
  function fitShip(msg, reached) {
    var t = msg.querySelector('.sa-ship-msg__text');
    if (!t || !msg.offsetWidth) return;
    var fontsOk = !document.fonts || document.fonts.status === 'loaded';
    var w = msg.offsetWidth + (fontsOk ? 'f' : '');
    if (msg.dataset.fitW === w) return;
    msg.dataset.fitW = w;
    var amt = t.querySelector('.sa-ship-msg__amount');
    var free = t.querySelector('.sa-ship-msg__free');
    t.style.removeProperty('font-size');
    t.style.removeProperty('white-space');
    if (amt) amt.style.removeProperty('font-size');
    if (free) free.textContent = 'gratuita';
    if (reached) return;
    var fs = 14;
    while (t.scrollWidth > t.clientWidth && fs > 12) {
      fs -= 0.5;
      t.style.setProperty('font-size', fs + 'px', 'important');
      if (amt) amt.style.setProperty('font-size', (fs + 1) + 'px', 'important');
    }
    /* "gratuita" deve leggersi sempre: se non ci sta diventa "gratis", e se ancora non basta va a capo */
    if (t.scrollWidth > t.clientWidth && free) free.textContent = 'gratis';
    if (t.scrollWidth > t.clientWidth) t.style.setProperty('white-space', 'normal', 'important');
  }
  /* il carattere del sito arriva dopo: quando e' pronto, e a ogni apertura del carrello, si ricalcola */
  function refitShip() {
    document.querySelectorAll('#rebuy-cart .sa-ship-msg').forEach(function (m) { m.dataset.fitW = ''; });
    schedule();
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refitShip);
  if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', refitShip);
  document.addEventListener('rebuy:smartcart.show', function () { setTimeout(refitShip, 350); });

  function celebrate(root, pb) {
    pb.classList.remove('sa-ship-pop');
    void pb.offsetWidth;
    pb.classList.add('sa-ship-pop');
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var host = root.querySelector('.rebuy-cart__flyout') || root;
    var box = document.createElement('div');
    box.className = 'sa-confetti';
    box.setAttribute('aria-hidden', 'true');
    var colors = ['#21542B', '#F39200', '#B51F1F', '#E8C547', '#6FA36B', '#F7B955'];
    var r = pb.getBoundingClientRect(), h = host.getBoundingClientRect();
    var ox = r.left - h.left + r.width / 2, oy = r.top - h.top + r.height / 2;
    for (var i = 0; i < 70; i++) {
      var p = document.createElement('i');
      var ang = Math.random() * Math.PI * 2, dist = 80 + Math.random() * 170;
      p.style.left = ox + 'px';
      p.style.top = oy + 'px';
      p.style.background = colors[i % colors.length];
      p.style.setProperty('--dx', Math.round(Math.cos(ang) * dist) + 'px');
      p.style.setProperty('--dy', Math.round(Math.sin(ang) * dist * 0.6 - 40) + 'px');
      p.style.setProperty('--fall', Math.round(160 + Math.random() * 260) + 'px');
      p.style.setProperty('--rot', Math.round(Math.random() * 720 - 360) + 'deg');
      p.style.animationDelay = Math.round(Math.random() * 120) + 'ms';
      if (i % 3 === 0) p.style.borderRadius = '50%';
      box.appendChild(p);
    }
    host.appendChild(box);
    setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 2600);
  }

  function subtotalText(t) {
    /* Rebuy scrive "Numero Articoli (1)" al singolare e "Totale (2 Articoli)" al plurale */
    var m = t.match(/numero articoli\s*\((\d+)\)/i) || t.match(/^\s*totale\s*\((\d+)\s*articol[oi]\)/i);
    if (!m) return t;
    var n = parseInt(m[1], 10);
    return 'Subtotale (' + n + (n === 1 ? ' articolo)' : ' articoli)');
  }

  function discount(root) {
    var box = root.querySelector('.rebuy-cart__discount-container');
    if (!box || box.querySelector('.sa-cart-discount-toggle')) return;
    var form = box.querySelector('.rebuy-cart__discount-form');
    if (!form) return;
    var input = form.querySelector('input');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sa-cart-discount-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Hai un codice sconto?';
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('sa-collapsed') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && input) input.focus();
    });
    box.insertBefore(btn, box.firstChild);
    /* chiuso, a meno che ci sia gia' un codice scritto o applicato */
    var applied = box.children.length > 2 || (input && input.value);
    if (!applied) box.classList.add('sa-collapsed');
    else btn.setAttribute('aria-expanded', 'true');
  }

  function apply() {
    var root = document.getElementById('rebuy-cart');
    if (!root) return;
    shipping(root);
    setText(root.querySelector('.rebuy-cart__flyout-subtotal-label span'), subtotalText);
    setText(root.querySelector('.rebuy-cart__checkout-button span'), function (t) {
      return /vai alla cassa/i.test(t) ? 'Vai alla cassa' : t;
    });
    root.querySelectorAll('[data-rebuy-component="cross-sell-widget"] .rebuy-product-actions .rebuy-button span').forEach(function (s) {
      setText(s, function (t) { return /^\s*aggiungi al carrello\s*$/i.test(t) ? 'Aggiungi' : t; });
    });
    var xsTitle = root.querySelector('[data-rebuy-component="cross-sell-widget"] .primary-title');
    setText(xsTitle, function (t) { return /completa la tua cena siciliana/i.test(t) ? 'Spesso acquistati insieme' : t; });
    discount(root);
    klarna(root);
    lockPage(root.classList.contains('is-visible'));
  }

  /* ---------- carrello aperto: la pagina sotto non scorre ----------
     Su iPhone, trascinando il dito nel carrello scorreva anche la pagina dietro. Finche' il carrello
     e' aperto la pagina resta ferma (position fixed alla posizione attuale); alla chiusura torna dov'era. */
  var locked = false, lockedY = 0;
  function lockPage(on) {
    if (on === locked) return;
    locked = on;
    var b = document.body, h = document.documentElement;
    if (on) {
      lockedY = window.scrollY || window.pageYOffset || 0;
      h.classList.add('sa-cart-locked');
      b.style.position = 'fixed';
      b.style.top = (-lockedY) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
    } else {
      h.classList.remove('sa-cart-locked');
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      window.scrollTo(0, lockedY);
    }
  }

  /* ---------- Klarna sopra "Vai alla cassa": stessa riga e stesse impostazioni della scheda prodotto
     (Theme Editor > Impostazioni > "SicilyAddict - Scheda prodotto"), calcolata sul totale del carrello ---------- */
  function money(cents) {
    var S = window.Rebuy && window.Rebuy.SmartCart;
    try { if (S && typeof S.formatMoney === 'function') return S.formatMoney(cents); } catch (e) {}
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function klarna(root) {
    var cfg = window.saKlarna;
    var area = root.querySelector('[data-rebuy-component="checkout-area"]');
    var btn = area && area.querySelector('.rebuy-cart__checkout-button');
    if (!btn) return;
    var row = area.querySelector('.sa-cart-klarna');
    var total = 0;
    try {
      var C = window.Rebuy.Cart;
      var cart = C.getCart && C.getCart();
      total = (cart && typeof cart.total_price === 'number') ? cart.total_price : C.subtotal();
    } catch (e) { total = 0; }
    var n = cfg ? parseInt(cfg.n, 10) || 0 : 0;
    var min = cfg ? Math.round((parseFloat(cfg.min) || 0) * 100) : 0;
    var show = cfg && cfg.enabled && n > 1 && total > 0 && total >= min;
    if (!show) { if (row) row.parentNode.removeChild(row); return; }
    var amount = Math.ceil(total / n);
    var key = n + ':' + amount;
    if (!row) {
      row = document.createElement('p');
      row.className = 'sa-cart-klarna';
    }
    if (row.nextSibling !== btn) area.insertBefore(row, btn);
    if (row.dataset.key !== key) {
      row.innerHTML = '<span class="sa-cart-klarna__badge" aria-hidden="true">Klarna</span>' +
        '<span class="sa-cart-klarna__txt">' + esc(cfg.prefix) + ' <strong>' + n + ' ' + esc(cfg.word) + ' ' + esc(money(amount)) + '</strong> ' + esc(cfg.suffix) + '</span>';
      row.dataset.key = key;
    }
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; apply(); });
  }

  var watched = null;
  function watch() {
    var root = document.getElementById('rebuy-cart');
    if (!root || root === watched) return;
    watched = root;
    new MutationObserver(schedule).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-valuenow'] });
    schedule();
  }

  /* anteprima tema: la barra di Shopify in basso copriva il pulsante "Vai alla cassa" */
  var pbar = null;
  function previewBar() {
    var w = document.getElementById('PBarNextFrameWrapper');
    var h = (w && getComputedStyle(w).display !== 'none') ? w.offsetHeight : 0;
    document.documentElement.style.setProperty('--sa-pbar-h', h + 'px');
    if (w && w !== pbar && window.ResizeObserver) { pbar = w; new ResizeObserver(previewBar).observe(w); }
  }

  /* ---------- quantita': risposta immediata ----------
     Con il + e il - di Rebuy passavano ~1,3 s prima che il numero cambiasse, e i click arrivati
     mentre salvava il precedente venivano persi (due + ravvicinati = +1).
     Qui i click su + e - li gestisce il tema: il numero cambia subito, i click si sommano e
     0,4 s dopo l'ultimo la quantita' finale va a Rebuy con Rebuy.Cart.setItemQuantity (una sola
     richiesta, carrello e eventi di Rebuy aggiornati come prima). Subtotale e barra spedizione
     restano "in caricamento" finche' Rebuy non conferma (rebuy:cart.change); poi le quantita'
     vengono riallineate con il carrello vero, nel caso Shopify ne abbia rifiutata una.
     Se l'API di Rebuy non c'e', i click passano a Rebuy come prima. */
  var busyTimer = null;
  function digitsNode(label) {
    for (var n = label && label.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && /\d/.test(n.nodeValue)) return n;
    }
    return null;
  }
  function endBusy() {
    if (Object.keys(qtyTimers).length) return; /* altri click ancora da inviare */
    clearTimeout(busyTimer);
    var root = document.getElementById('rebuy-cart');
    if (!root || !root.classList.contains('sa-cart-busy')) return;
    root.classList.remove('sa-cart-busy');
    root.querySelectorAll('.sa-removing').forEach(function (li) { li.classList.remove('sa-removing'); });
    resyncQty(root);
  }
  function resyncQty(root) {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (root.classList.contains('sa-cart-busy')) return; /* nuovi click nel frattempo: aspetta Rebuy */
        root.querySelectorAll('.rebuy-cart__flyout-item').forEach(function (li) {
          var handle = '';
          li.classList.forEach(function (c) { if (!handle && c.indexOf('product-') === 0) handle = c.slice(8); });
          var variant = (li.querySelector('.rebuy-cart__flyout-item-variant-title') || {}).textContent || '';
          var matches = cart.items.filter(function (it) { return it.handle === handle; });
          if (matches.length > 1) matches = matches.filter(function (it) { return (it.variant_title || '').trim() === variant.trim(); });
          if (matches.length !== 1) return;
          var node = digitsNode(li.querySelector('.rebuy-cart__flyout-item-quantity-widget-label'));
          var want = String(matches[0].quantity);
          if (node && node.nodeValue.replace(/\D/g, '') !== want) node.nodeValue = ' ' + want + ' ';
        });
      })
      .catch(function () {});
  }
  function liHandle(li) {
    var handle = '';
    li.classList.forEach(function (c) { if (!handle && c.indexOf('product-') === 0) handle = c.slice(8); });
    return handle;
  }
  function rebuyItem(li) {
    var Cart = window.Rebuy && window.Rebuy.Cart;
    if (!Cart || typeof Cart.items !== 'function' || typeof Cart.setItemQuantity !== 'function') return null;
    var handle = liHandle(li);
    var variant = ((li.querySelector('.rebuy-cart__flyout-item-variant-title') || {}).textContent || '').trim();
    var list;
    try { list = Cart.items() || []; } catch (err) { return null; }
    list = list.filter(function (it) { return it.handle === handle; });
    if (list.length > 1) list = list.filter(function (it) { return (it.variant_title || '').trim() === variant; });
    return list.length === 1 ? list[0] : null;
  }
  var qtyTimers = {};
  function startBusy(root) {
    root.classList.add('sa-cart-busy');
    clearTimeout(busyTimer);
    busyTimer = setTimeout(endBusy, 8000);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#rebuy-cart .rebuy-cart__flyout-item-quantity-widget-button');
    if (!btn) return;
    var root = document.getElementById('rebuy-cart');
    var li = btn.closest('.rebuy-cart__flyout-item');
    var widget = btn.closest('.rebuy-cart__flyout-item-quantity-widget');
    var node = digitsNode(widget && widget.querySelector('.rebuy-cart__flyout-item-quantity-widget-label'));
    var item = li && rebuyItem(li);
    if (!node || !item) return; /* niente API: decide Rebuy */
    e.preventDefault();
    e.stopImmediatePropagation();
    var buttons = widget.querySelectorAll('.rebuy-cart__flyout-item-quantity-widget-button');
    var step = (item.quantity_rule && item.quantity_rule.increment) || 1;
    var delta = btn === buttons[0] ? -step : step;
    var next = Math.max(0, (parseInt(node.nodeValue.replace(/\D/g, ''), 10) || 0) + delta);
    node.nodeValue = ' ' + next + ' ';
    li.classList.toggle('sa-removing', next === 0);
    startBusy(root);
    var key = item.key || item.id;
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      delete qtyTimers[key];
      var fresh = rebuyItem(li) || item;
      if (fresh.quantity === next) { endBusy(); return; }
      try {
        window.Rebuy.Cart.setItemQuantity(fresh, next, { error: function () { endBusy(); } });
      } catch (err) { endBusy(); }
    }, 400);
  }, true);
  document.addEventListener('rebuy:cart.change', function () { setTimeout(endBusy, 60); setTimeout(headerCount, 60); setTimeout(schedule, 80); });

  /* Pallino dell'header: Rebuy aggiorna ".cart-count", che in questo tema non esiste, quindi il
     numero restava fermo quando si cambiavano quantita' o si toglievano prodotti dal carrello. */
  function headerCount() {
    var S = window.Rebuy && window.Rebuy.SmartCart;
    if (!S || typeof S.itemCount !== 'function') return;
    var n;
    try { n = S.itemCount(); } catch (err) { return; }
    if (typeof n !== 'number') return;
    document.querySelectorAll('.header__cart-count').forEach(function (el) {
      if (el.textContent.trim() !== String(n)) el.textContent = n;
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#rebuy-cart .rebuy-cart__flyout-item-remove')) {
      var root = document.getElementById('rebuy-cart');
      var li = e.target.closest('.rebuy-cart__flyout-item');
      if (li) li.classList.add('sa-removing');
      root.classList.add('sa-cart-busy');
      clearTimeout(busyTimer);
      busyTimer = setTimeout(endBusy, 6000);
    }
  }, true);

  function init() {
    watch();
    previewBar();
    new MutationObserver(function () { watch(); previewBar(); }).observe(document.body, { childList: true });
  }
  ['rebuy:smartcart.ready', 'rebuy:smartcart.show', 'rebuy:cart.change'].forEach(function (e) {
    document.addEventListener(e, function () { watch(); schedule(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
